import { render, staticRenderFns } from "./FormCulturalOrganization.vue?vue&type=template&id=ac810ae4&"
import script from "./FormCulturalOrganization.vue?vue&type=script&lang=js&"
export * from "./FormCulturalOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac810ae4')) {
      api.createRecord('ac810ae4', component.options)
    } else {
      api.reload('ac810ae4', component.options)
    }
    module.hot.accept("./FormCulturalOrganization.vue?vue&type=template&id=ac810ae4&", function () {
      api.rerender('ac810ae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/culturalOrganization/form/FormCulturalOrganization.vue"
export default component.exports